export default __webpack_public_path__ + "static/media/iconRejectCompany.ecfb75fc.svg";